// evr-firebase-core.js
// Globale Firebase-Initialisierung + getAuthForEnv/resolveEnv, verwendbar auf allen Seiten.

window.EVR = window.EVR || {};

(function (global) {
  // --- Firebase Konfigurationen für alle Umgebungen ---
  const firebaseConfigs = {
    dev: {
      apiKey: "AIzaSyCgisdbANtRHAHUmTNGSbZ-hIIsnCN9lvM",
      authDomain: "eversion-test.firebaseapp.com",
      projectId: "eversion-test",
      storageBucket: "eversion-test.appspot.com",
      messagingSenderId: "565917657512",
      appId: "1:565917657512:web:a1055055e4f7effbda559d",
      measurementId: "G-E8S4VH2CM8"
    },
    qa: {
      apiKey: "AIzaSyB7gqQbOCShbK_OiB3Wu3s40v_bjgVz5e8",
      authDomain: "evr-measure-qa.firebaseapp.com",
      projectId: "evr-measure-qa",
      storageBucket: "evr-measure-qa.firebasestorage.app",
      messagingSenderId: "379779069406",
      appId: "1:379779069406:web:6cb2771d8b5d92e7aa594f",
      measurementId: "G-RRXBZKRXB2"
    },
    staging: {
      apiKey: "AIzaSyC6J_pr099JPJVge6xLNefp5e2aZnYhDFI",
      authDomain: "evr-measure-staging.firebaseapp.com",
      projectId: "evr-measure-staging",
      storageBucket: "evr-measure-staging.firebasestorage.app",
      messagingSenderId: "1090938432669",
      appId: "1:1090938432669:web:d7545c5df145ca7c5a3874",
      measurementId: "G-7Z6YRYVXVJ"
    },
    prod: {
      apiKey: "AIzaSyApezrmXZ6aM4f2rTJQOInGscTcCql9yXM",
      authDomain: "evr-measure-prod.firebaseapp.com",
      projectId: "evr-measure-prod",
      storageBucket: "evr-measure-prod.firebasestorage.app",
      messagingSenderId: "655745252499",
      appId: "1:655745252499:web:89ddb86ed088a0823a6166",
      measurementId: "G-HDJ1GXK3DH"
    }
  };

  // --- Environment-Handling: ?env=dev → localStorage("env") ---
  function resolveEnv() {
    try {
      const url = new URL(window.location.href);
      const queryEnv = (url.searchParams.get("env") || "").toLowerCase();
      const storedEnv = (window.localStorage.getItem("env") || "prod").toLowerCase();
      const env = queryEnv || storedEnv || "prod";
      window.localStorage.setItem("env", env);
      return env;
    } catch (e) {
      console.warn("[EVR Firebase] resolveEnv failed, using prod:", e);
      return "prod";
    }
  }

  function getConfig(envKey) {
    const env = (envKey || resolveEnv() || "prod").toLowerCase();
    return firebaseConfigs[env] || firebaseConfigs.prod;
  }

  function getAuthForEnv(envKey) {
    const env = (envKey || resolveEnv() || "prod").toLowerCase();

    if (!global.firebase || !global.firebase.initializeApp) {
      console.error("[EVR Firebase] Firebase SDK not loaded.");
      return null;
    }

    const config = getConfig(env);

    if (!global.EVR.firebaseApp) {
      global.EVR.firebaseApp = firebase.initializeApp(config);
      global.EVR.firebaseEnv = env;
      console.log("[EVR Firebase] Initialized app for env:", env);
    } else if (global.EVR.firebaseEnv !== env) {
      console.warn(
        `[EVR Firebase] App already initialized for env=${global.EVR.firebaseEnv}. ` +
          `Ignoring request to re-init for env=${env}.`
      );
    }

    return firebase.auth(global.EVR.firebaseApp);
  }

  // Global verfügbar machen
  global.EVR.resolveEnv = resolveEnv;
  global.EVR.getAuthForEnv = getAuthForEnv;
})(window);